import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class UpdateClaim extends Vue {
	public errorSave: boolean = false;
	public success: boolean = false;
	public claimId: string = '';
	public claim: any = {};
	public claimStatus: string = '';
	public assignee: string = '';
	public comments: string = '';
	public setup: boolean = false;
	public isInvalid: boolean = false;
	public loading: boolean = true;
	public error: boolean = false;
	public realClaimId: string = '';
	public peerSupportRequested: boolean = false;
	public peerSupportSwitched: boolean = false;
	public claimNumberUpdated: boolean = false;
	public peerSupportFields: any = {
		NameOfInsured: '',
		ClinicHospital: '',
		CreateDateTime: '',
		Specialty: '',
		PreferredContactMethod: '',
		CasefileNumber: '',
		ClaimConsultantName: '',
		ClaimConsultantEmail: '',
		ClaimConsultantPhone: '',
		DefenseAttorney: '',
		DefenseAttorneyEmail: '',
		DescriptionOfOccurrence: '',
		Comments: '',
		InsuredEmail: '',
		InsuredPhone: '',
		ClaimStatus: '',
		PeerSupportRequested: false,
	};
	public additionalFields: any = {
		caseType: '',
		claimConsultantName: '',
		claimConsultantEmail: '',
		claimConsultantPhone: '',
		managerLeadName: '',
		lossType: '',
		expenseReserves: '',
		indemnityReserves: '',
		allegations: '',
		injuries: '',
		bodyParts: '',
		severity: '',
		patientClass: '',
	};

	private async updateClaim() {
		try {
			const updateClaim = await Staff.updateClaim({
				claim_id: this.claimId,
				real_claim_id: this.realClaimId,
				claim_status: this.claimStatus,
				assignee: this.assignee,
				comments: this.comments,
				setup: this.setup,
				additionalFields: this.additionalFields,
				peerSupportRequested: this.peerSupportRequested,
			});

			this.success = true;
		} catch (e) {
			Sentry.captureException(e);
			this.errorSave = true;
		}
	}

	private async updatePeerSupport(isRequestPeerSupportEnabled) {
		if (isRequestPeerSupportEnabled && this.peerSupportRequested && this.peerSupportSwitched) {
			try {
				await Staff.createCPSPSupportRequest(this.peerSupportFields);

				this.success = true;
			} catch (e) {
				Sentry.captureException(e);
				this.errorSave = true;
			} finally {
				this.peerSupportSwitched = false;
				this.claimNumberUpdated = false;
			}
		}
		if (
			this.claimNumberUpdated &&
			isRequestPeerSupportEnabled &&
			this.peerSupportRequested &&
			!this.peerSupportSwitched
		) {
			try {
				await Staff.updateCPSPSupportRequest(this.peerSupportFields);

				this.success = true;
			} catch (e) {
				Sentry.captureException(e);
				this.errorSave = true;
			}
		}
	}
}
